import { render, staticRenderFns } from "./SystemMessageDetail.vue?vue&type=template&id=64e285c6&scoped=true&"
import script from "./SystemMessageDetail.vue?vue&type=script&lang=js&"
export * from "./SystemMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageDetail.vue?vue&type=style&index=0&id=64e285c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e285c6",
  null
  
)

export default component.exports